export default class Filters {
  static account(value: string): boolean {
    return /^\d{0,14}$/.test(value);
  }

  static phone(value: string): boolean {
    return /^\d{0,10}$/.test(value);
  }

  static postalCode(value: string): boolean {
    return /^\d{0,5}$/.test(value);
  }

  static text(value: string): boolean {
    return /^.*$/.test(value);
  }
}
